import UserManage from './UserManage.jsx';

export default UserManage;